import React, { Component } from 'react'
import { connect } from 'react-redux'
import trans, { isTrans } from 'trans'
import { AxiosResponse } from "axios"
import store from "store"

import { setBlockNavigation } from "../reducers"
import { initForm, updateInputValue as change, selectFormValue } from "app/reducers/form"
import { clearHistory, redoHistory, TemplateOrAlternativeTemplateType, undoHistory, UndoRedoHistory } from "template-edit/undoRedoReducers"
import { setActiveGroupId, setActiveShapeId, setActiveView } from "shape-edit/reducers"
import { selectLayers } from "shape-list/reducers"

import {
    applyEffectsToRandomProduct,
    getAskBeforeLeave, getProjectSettings,
    getRandomProduct, godProjectId, isGodModeOn,
    projectId, setDisableShowOverlap, getWatermarkGroups,
    getInpaintingGroups,
    getFontsUsedInProject,
    customImageSetFileGetImageBlob,
    imageFromElementsGetImageBlob,
} from "app/helpers/api";

import {
    createToast,
    setFontsInProjectToStore,
    setRandomProduct,
    setRandomProductIsLoading,
} from "actions";

import { ReduxList } from "app/types/app-types"
import { InpaintingGroupType, RENDERED_TYPE_AUTOWMREMOVE, RENDERED_TYPE_BGREMOVE, RENDERED_TYPE_INPAINTING, RENDERED_TYPE_OUTPAINTING, RENDERED_TYPE_UPSCALE, WatermarkGroupType } from "products/types";
import { RandomProduct } from "shape-edit/types"
import RightPanel from "shape-edit/containers/right-panel";
import ImagePreview, { MAX_ZOOM, MIN_ZOOM } from "./image-preview"

import {
    css,
    modal,
    Button,
    Grid,
    GridCell,
    Icon,
} from "@bdfx/mergado-ui-kit"

import ToolsPanel from "../components/tools-panel";
import Helper, { testUsers } from "../components/helper";
import { CoordsType } from "shape-entities/components/shape";

import {
    SettingsFormType,
    EffectsType,
    BrushFormType,
    initBrushForm,
    AlternativeTemplatesLevels,
    Project,
} from "app/types/model-types";

import { echo } from "app/components/websocketeer";
import { ID, intboolean } from "app/types/app-types";
import { textToast } from "app/helpers/toast_factory";
import { invertColor, isJson } from "app/helpers/other";
import { RouterType, withRouter } from "app/components/routes";
import { canBeOutpaintedOver, getFontsFromForm, getFormName, getSelectedAltLevels, isTemplateSaved } from "shape-edit/forms/helpers";
import { setWatermarkGroupsToStore, setInpaintingGroupsToStore } from "watermark-groups/reducers";
import WatermarksInEditor from './watermarks-in-editor';
import { MIN_IMAGES_WITH_MASKS_TO_PUBLISH } from 'watermark-groups/watermark-groups-select';
import { selectFormValues } from 'app/reducers/form'
import { debounce, find, forEach } from 'lodash';
import InpaintingInEditor from './inpainting-in-editor'
import { LevelsModeType } from 'template-edit/components/save-template-form'
import Shape from 'shape-entities/types/shape'

export type ActiveViewType = 'edit-source-image' | 'shape-selection' | 'edit-queries' | 'new-shape' | 'edit-shape' | 'template-gallery' | 'edit-auto-onoff' | 'edit-effects' | 'ai-elements'
export type UpdateEffectsFunctionType = (productId: ID,
    newEffects: EffectsType,
    isAutocrop: intboolean,
    altLevels: string[],
    altLevelsMode: LevelsModeType,
    newPublished?: boolean,
    thisRandomProduct?: RandomProduct,
    isForce?: boolean
) => void

export const ACTIVE_VIEW_EDIT_SOURCE_IMAGE = 'edit-source-image'
export const ACTIVE_VIEW_EDIT_SHAPE = 'edit-shape'
export const ACTIVE_VIEW_EDIT_QUERIES = 'edit-queries'
export const ACTIVE_VIEW_SHAPE_SELECTION = 'shape-selection'
export const ACTIVE_VIEW_NEW_SHAPE = 'new-shape'
export const ACTIVE_VIEW_TEMPLATE_GALLERY = 'template-gallery'
export const ACTIVE_VIEW_EDIT_AUTO_ON_OFF = 'edit-auto-onoff'
export const ACTIVE_VIEW_EDIT_EFFECTS = 'edit-effects'
export const ACTIVE_VIEW_AI_ELEMENTS = 'ai-elements'

interface Props {
    alternativeTemplatesLevels: ReduxList<AlternativeTemplatesLevels>
    project: Project
    isAlt: boolean
    queries: string[]
    form: TemplateOrAlternativeTemplateType
    templateId: ID
    altTemplateId: ID
    router: RouterType
    blockNavigation: boolean
    lockedLayers: string[]
    brushForm: BrushFormType
    activeView: ActiveViewType
    projectSettings: SettingsFormType
    randomProduct: RandomProduct
    undoRedoHistory: UndoRedoHistory
    watermarkGroups: ReduxList<WatermarkGroupType[]>
    inpaintingGroups: ReduxList<InpaintingGroupType[]>
    setRandomProduct: typeof setRandomProduct
    setRandomProductIsLoading: typeof setRandomProductIsLoading
    setFontsInProjectToStore: typeof setFontsInProjectToStore
    undoHistory: typeof undoHistory
    redoHistory: typeof redoHistory
    clearHistory: typeof clearHistory
    setActiveView: typeof setActiveView
    setActiveShapeId: typeof setActiveShapeId
    setActiveGroupId: typeof setActiveGroupId
    selectLayers: typeof selectLayers
    setBlockNavigation: typeof setBlockNavigation
    initForm: typeof initForm
    change: typeof change
    setWatermarkGroupsToStore: typeof setWatermarkGroupsToStore
    setInpaintingGroupsToStore: typeof setInpaintingGroupsToStore
}

interface State {
    sameImageInPreview: boolean
    confirmedNavigation: boolean
    isAskBeforeLeave: boolean

    isLoadingRandomProduct: boolean
    isUpdatingEffects: boolean
    willUpdate: boolean

    isProcessing: boolean
    done: boolean
    published: boolean

    invalid: string[]
    canvasZoom: number
    canvasTranslate: CoordsType
    mouseOverShape: string

    processingProductId: number
    updatedGroupName: string
    showAsModal: boolean    //true = show as modal, false = show inline, null = close
}

export type WebSocketMessage = {
    is_alt: boolean
    image_or_alt_image_id: number
    image_or_alt_image_hash?: string
    custom_set_file_id?: number
    shape_index?: string
    product_id: number
    project_id: number
    template_id?: number
    width?: number
    height?: number
    sensitivity?: string
    method?: string
    watermark_group_id?: number
    inpainting_group_id?: number
    status: string
    error?: string
}

export type SupereffectType = 'background' | 'upscale' | 'watermark' | 'outpainting' | 'inpainting'

class Editor extends Component<Props, State> {
    timer: NodeJS.Timeout
    updateEffectsCounter: number
    publishCounter: number
    shouldUpdateEffects: boolean

    constructor(props: Props) {
        super(props);
        const actualProjectId = isGodModeOn ? godProjectId : projectId

        //important: socket.io-client needs to be in version ^2.3.x!!!
        echo.channel(`private-project.${actualProjectId}`)
            .listen('.background.removed', (event) => this.handleProcessDone(event, 'background'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.background.started', (event) => this.handleProcessStarted(event, 'background'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.upscale.done', (event) => this.handleProcessDone(event, 'upscale'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.upscale.started', (event) => this.handleProcessStarted(event, 'upscale'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.autowatermark.removed', (event) => this.handleProcessDone(event, 'watermark'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.autowatermark.started', (event) => this.handleProcessStarted(event, 'watermark'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.outpainting.started', (event) => this.handleProcessStarted(event, 'outpainting'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.outpainting.error', (event) => this.handleProcessError(event, 'outpainting'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.outpainting.done', (event) => this.handleProcessDone(event, 'outpainting'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.inpainting.started', (event) => this.handleProcessStarted(event, 'inpainting'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.inpainting.error', (event) => this.handleProcessError(event, 'inpainting'))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.inpainting.done', (event) => this.handleProcessDone(event, 'inpainting'))


        this.state = {
            sameImageInPreview: true,
            confirmedNavigation: false,
            isAskBeforeLeave: false,
            isLoadingRandomProduct: false,
            isUpdatingEffects: false,
            isProcessing: false,
            willUpdate: false,
            done: false,
            published: false,
            invalid: [],
            canvasZoom: 1,
            canvasTranslate: { x: 0, y: 0 },
            mouseOverShape: null,
            processingProductId: null,
            updatedGroupName: '',
            showAsModal: window.location.pathname.endsWith('/templates/new'),
        }

        this.updateEffectsCounter = 0
        this.publishCounter = 0
        this.shouldUpdateEffects = !!props.form.is_autocrop  //todo: toto jenom pokud je autocrop nebo effects??
    }

    transSupereffect = (type: SupereffectType): string => {
        const t = {
            upscale: 'upscale_image',
            background: 'remove_background',
            watermark: 'remove_watermark',
            outpainting: 'outpainting',
            inpainting: 'inpainting'
        }
        return (t[type] || 'undefined_process')
    }

    setShowAsModal = (value: boolean) => {
        this.setState({ showAsModal: value })
    }

    setShowOverlap = (value: boolean) => {
        setDisableShowOverlap(!value)
            .then((response: AxiosResponse<SettingsFormType>) => {
                this.props.initForm('settingsForm', response.data)
            })
            .catch((error) => {
                console.error('cannot save show overlap', error)
            })
    }

    handleProcessError = (message: WebSocketMessage, type: SupereffectType) => {
        const { form, isAlt } = this.props
        //pozor, randomProduct.id === message.product_id: toto nebude sedet, pokud je refresh random produktu, je tu stare id nebo zadne!!!!
        if (message.project_id === form.project_id && form.type) {
            const transString = this.transSupereffect(type)

            console.error('error', message)
            /* modal({
                overlayClassName: 'outpainting-info-modal',
                title: <Icon type={'settings-light'} size={28} text={transString} />,
                message: (close) => <div>
                    {message.error}
                </div>,
                closeOnClickOutside: true,
                closeOnEscape: true,
            }) */

            this.setState({
                processingProductId: message.product_id,
                published: true,
                isProcessing: false,
                done: true,
            })

            console.debug((isTrans(`${transString}_error`)) ? trans(`${transString}_error`) : `${transString}_error`, message)
        }
    }

    handleProcessStarted = (message: WebSocketMessage, type: SupereffectType) => {
        const { form, randomProduct, isAlt } = this.props

        //pozor, randomProduct.id === message.product_id: toto nebude sedet, pokud je refresh random produktu, je tu stare id nebo zadne!!!!
        console.debug(`handle process started? this random product: ${randomProduct.id} vs result for ${message.product_id}`)
        if (message.project_id === form.project_id && form.type && (!randomProduct.id || (`${randomProduct.id}` === `${message.product_id}`))) {
            const transString = this.transSupereffect(type)
            this.publishCounter++
            this.setState({
                processingProductId: message.product_id,
                published: true,
                isProcessing: true,
                done: false,
            })
            console.debug('---------------------------------------' + (isTrans(`${transString}_started`)) ? trans(`${transString}_started`) : `${transString}_started`, message)
        }
    }

    handleProcessDone = (message: WebSocketMessage, type: SupereffectType) => {
        const { randomProduct, form, isAlt } = this.props
        const { isUpdatingEffects, isLoadingRandomProduct, processingProductId } = this.state

        if (message.project_id === form.project_id) {
            console.debug(`process (${type}) DONE. Product ${message.product_id} (${randomProduct.id}) ${message.status}`)
            if (message.image_or_alt_image_id && `${message.image_or_alt_image_id}`.startsWith('customimage_') && message.custom_set_file_id && message.shape_index) {
                if (message.status === 'OK') {
                    //check and rerender custom images with is_remove_background set
                    const formName = getFormName(isAlt)
                    customImageSetFileGetImageBlob(message.custom_set_file_id, 1, message.shape_index)
                        .then((response: AxiosResponse<string>) => {
                            const imageBlob = response.data

                            const shape = this.props.form.shapes[message.shape_index] as Shape

                            this.props.change(formName, `shapes.${message.shape_index}`, {
                                ...shape,
                                imageBlob: imageBlob,
                                is_remove_background: 1,
                            })
                        })
                        .catch((error) => {
                            console.error('customImageSetFileGetImageBlob error', error)
                        })

                } else {
                    console.error(`customImageSetFileGetImageBlob: status: ${message.status} reason: ${message.error}`)
                }
            } else if (message.image_or_alt_image_id && `${message.image_or_alt_image_id}`.startsWith('imagefromelement_') && message.shape_index && randomProduct?.id === message.product_id) {
                if (message.status === 'OK') {
                    //check and rerender custom images with is_remove_background set
                    const formName = getFormName(isAlt)
                    const shape = this.props.form.shapes[message.shape_index] as Shape
                    const content = shape.image_xml_element && randomProduct.serialized_data && typeof randomProduct.serialized_data[shape.image_xml_element] !== 'undefined' ? randomProduct.serialized_data[shape.image_xml_element] : null

                    console.debug(`the message ${message.shape_index} ${message.product_id} ${message.shape_index} content ${content}`)

                    imageFromElementsGetImageBlob(randomProduct?.id, content, shape.is_remove_background, message.shape_index)
                        .then((response: AxiosResponse<string>) => {
                            const imageBlob = response.data
                            console.debug(`return image blob ${imageBlob}`)

                            this.props.change(formName, `shapes.${message.shape_index}`, {
                                ...shape,
                                imageBlob: imageBlob,
                                is_remove_background: shape.is_remove_background,
                            })

                        })
                        .catch((error) => {
                            console.error('imageFromElement: getImageBlob error', error)
                        })
                        .finally(() => {
                            console.debug(`finally setting state done`, this.state.published, this.state.isProcessing, this.state.processingProductId)
                            this.setState({
                                published: false,
                                isProcessing: false,
                                done: true,
                                processingProductId: null,
                            })
                        })

                } else {
                    console.error(`imageFromElement: status: ${message.status} reason: ${message.error}`)

                }
            } else if (
                (!randomProduct.id || randomProduct.id === message.product_id || message.product_id === processingProductId) &&
                (!((form.type === RENDERED_TYPE_AUTOWMREMOVE) && form.watermark_group_id)
                    || form.watermark_group_id === message.watermark_group_id
                    || form.inpainting_group_id === message.inpainting_group_id
                )
            ) {
                const shouldOutpaintedOver = form.type === RENDERED_TYPE_OUTPAINTING && canBeOutpaintedOver(form.outpaint_over, form.overscan, form.translate_x, form.translate_y)

                const expectedOverscan = shouldOutpaintedOver ? form.overscan : null
                const expectedTranslateX = shouldOutpaintedOver ? form.translate_x : 0
                const expectedTranslateY = shouldOutpaintedOver ? form.translate_y : 0

                const imageBlobTypeDiff = !randomProduct.imageBlobType ||
                    randomProduct.imageBlobType.templateType !== form.type ||
                    randomProduct.imageBlobType.overscan !== expectedOverscan ||
                    randomProduct.imageBlobType.translate_x !== expectedTranslateX ||
                    randomProduct.imageBlobType.translate_y !== expectedTranslateY

                const should = message.status === 'OK' && form.type && imageBlobTypeDiff
                this.shouldUpdateEffects = (isUpdatingEffects || isLoadingRandomProduct || should),    //or non empty effects? update once!!!!

                    this.setState({
                        published: false,
                        isProcessing: false,
                        done: true,
                        processingProductId: null,
                    })

                const transString = this.transSupereffect(type)

                if (message.status === 'ERROR') {
                    console.debug(trans(`${transString}_error`), message)
                } else if (message.status === 'NOT_OK') {
                    store.dispatch(createToast(textToast('error', trans(`${transString}_not_ok`))))
                } else {
                    const a = getSelectedAltLevels()
                    this.updateEffectsDebounced(message.product_id, form.effects, form.is_autocrop, a?.levels, a?.mode)
                }

                if (randomProduct.id !== message.product_id) {
                    console.debug(`different product: ${randomProduct.id} vs ${message.product_id}`)
                }

                console.debug(`-------------------------------------- ${this.updateEffectsCounter} ----` + (isTrans(`${transString}_done`)) ? trans(`${transString}_done`) : `${transString}_done`, message)
            }
        }
    }

    updateEffectsDebounced = debounce((productId: ID, newEffects: EffectsType, isAutocrop: intboolean, altLevels: string[], altLevelsMode: LevelsModeType, thisRandomProduct: RandomProduct = null) => {
        if (productId) {
            this.updateEffects(productId, newEffects, isAutocrop, altLevels, altLevelsMode, null, thisRandomProduct ? thisRandomProduct : this.props.randomProduct)
        }
    }, 200)

    updateEffects : UpdateEffectsFunctionType = (productId: ID, newEffects: EffectsType, isAutocrop: intboolean, altLevels: string[], altLevelsMode: LevelsModeType, newPublished: boolean = null, thisRandomProduct: RandomProduct = null, isForce: boolean = null) => {
        const { isUpdatingEffects, isProcessing, published, processingProductId } = this.state
        const { form, isAlt, templateId } = this.props

        const randomProduct = thisRandomProduct ? thisRandomProduct : this.props.randomProduct

        if (typeof newPublished !== "undefined") {
            this.setState({ published: newPublished && (!processingProductId || `${processingProductId}` !== `${productId}`) })
        }

        const isLoadingRandomProduct = randomProduct?.isLoading
        const effectsDiff = JSON.stringify(newEffects) !== JSON.stringify(form.effects)  //make preview when brightness/contrast changed while waiting for ai result
        const levelsDiff = altLevels && Array.isArray(altLevels) && altLevels.length && (randomProduct.activeLevelFromZero === null || !altLevels.includes(`${randomProduct.activeLevelFromZero}`))

        if (this.publishCounter > 6) {
            console.debug(`.......... too many attempts (${this.publishCounter}), nothing to do`)
        } else if (randomProduct && productId && randomProduct.id && `${productId}` === `${randomProduct.id}` && !isUpdatingEffects && (this.shouldUpdateEffects || effectsDiff || levelsDiff || isForce) && !isLoadingRandomProduct && !isProcessing) {
            this.updateEffectsCounter++
            console.debug(`----- START updating effects ${productId} ${published ? '(already published, no action!)' : ''}`)

            this.setState({
                isUpdatingEffects: true,
            })

            applyEffectsToRandomProduct({ ...randomProduct, published: newPublished }, { ...form, effects: newEffects, is_autocrop: isAutocrop ? 1 : null }, templateId, altLevels, altLevelsMode, isAlt)
                .then((response: AxiosResponse<RandomProduct>) => {
                    if (response.data.error) {
                        console.error('error', response.data.error)
                        this.createErrorToast(response.data.error)
                    }

                    if (
                        response.data.imageBlob !== randomProduct.imageBlob ||
                        response.data.bgremovedImage !== randomProduct.bgremovedImage ||
                        response.data.activeLevelFromZero !== randomProduct.activeLevelFromZero
                    ) {
                        this.props.setRandomProduct(response.data)

                        if (this.shouldUpdateEffects && this.updateEffectsCounter <=10) {
                            console.debug('------------------------------------------------ calling debounced, state is should update', this.state)
                            this.updateEffectsDebounced(productId, form.effects, form.is_autocrop, altLevels, altLevelsMode)  //start updating main image --> background removed --> main image updated   would miss update of effects
                        }

                        this.setState({
                            published: response.data.published,
                            done: response.data.done,
                        })
                    }
                })
                .catch((e) => {
                    console.error('error updating effect', e)
                })
                .finally(() => {
                    this.setState({
                        isUpdatingEffects: false,
                    })
                    this.shouldUpdateEffects = false
                    console.debug(`----- END updating effects ${productId}`)
                })
        }
    }

    updateZoom = (zoom: number) => {
        const updatedZoom = zoom > MAX_ZOOM ? MAX_ZOOM : (zoom < MIN_ZOOM ? MIN_ZOOM : zoom)
        this.setState({ canvasZoom: updatedZoom })
    }

    updateTranslate = (translate: CoordsType) => {
        this.setState({ canvasTranslate: translate })
    }

    componentDidMount(): void {
        const { form, isAlt } = this.props

        this.props.setActiveShapeId(null)

        this.updateWatermarkGroups()
        this.updateInpaintingGroups()

        if (isAlt) {
            this.props.setActiveView(ACTIVE_VIEW_TEMPLATE_GALLERY)    //shape-selection
        } else if (window.location.pathname.endsWith('/templates/new')) {
            this.props.setActiveView(ACTIVE_VIEW_EDIT_QUERIES)
        } else {
            this.props.setActiveView(form.is_keep_size ? ACTIVE_VIEW_TEMPLATE_GALLERY : ACTIVE_VIEW_SHAPE_SELECTION)

            if (form.queries?.length === 0 || form.type === RENDERED_TYPE_UPSCALE) {
                this.props.setActiveView(ACTIVE_VIEW_EDIT_QUERIES)
            }
        }

        this.props.selectLayers()

        const userId = this.props.project?.user?.id
        if (!userId || !testUsers.includes(userId)) {
            getAskBeforeLeave()
                .then(r => {
                    const isAskBeforeLeave = r.data
                    this.setState({ isAskBeforeLeave: isAskBeforeLeave })
                })
                .catch(e => {
                    console.error('error while reading settings', e)
                })
        } else {
            console.debug(`skipping isAskBeforeLeave for user ${userId}`)
        }


        if (!this.props.projectSettings) {
            getProjectSettings()
                .then((response: AxiosResponse<SettingsFormType>) => {
                    this.props.initForm('settingsForm', response.data)
                })
                .catch(error => {
                    console.error('cannot get settings', error)
                })
        }

        if (!this.props.brushForm || !this.props.brushForm.radius) {
            this.props.initForm('brushForm', {
                ...initBrushForm,
                color: this.props.randomProduct?.palette ? invertColor(this.props.randomProduct.palette[0]) : initBrushForm.color
            })
        }

        getFontsUsedInProject()
            .then((response: AxiosResponse<string[]>) => {
                //1. fonts from whole projects
                let fontsInProject = response.data

                //2. merge with fonts in current form
                const fontsFromForm = getFontsFromForm()
                forEach(fontsFromForm, (fontFromForm: string) => {
                    if (!fontsInProject.includes(fontFromForm)) {
                        fontsInProject.push(fontFromForm)
                    }
                })

                //3. update in store
                this.props.setFontsInProjectToStore(fontsInProject)
            })
            .catch(error => {
                console.error('error while getting used fonts', error)
            })

    }

    setMouseOverShape = (index: string) => {
        if (index !== this.state.mouseOverShape) {
            this.setState({ mouseOverShape: index })
        }
    }

    toggleSameImageInPreview = (sameImageInPreview: boolean) => this.setState({ sameImageInPreview: sameImageInPreview })

    createErrorToast = (error: string) => {
        console.debug('create toast error', error)

        if (error === 'too_big_for_upscale') {
            store.dispatch(createToast(textToast('error', trans(error))))
        }
    }

    updateWatermarkGroups = () => {
        getWatermarkGroups()
            .then((response: AxiosResponse<WatermarkGroupType[]>) => {
                this.props.setWatermarkGroupsToStore(response.data)
            })
            .catch(e => {
                console.error('cannot get watermark groups', e)
            })
    }

    updateInpaintingGroups = () => {
        getInpaintingGroups()
        .then((response: AxiosResponse<InpaintingGroupType[]>) => {
                this.props.setInpaintingGroupsToStore(response.data)
            })
            .catch(e => {
                console.error('cannot get inpainting groups', e)
            })
    }

    handleImageRefresh = (fromModal: boolean = false, preferredProductId: string = null) => {
        const { randomProduct, form, queries, templateId, altTemplateId } = this.props
        const { isLoadingRandomProduct } = this.state

        if (form && !isLoadingRandomProduct && (!randomProduct || !randomProduct.isLoading)) {
            this.setState({ isLoadingRandomProduct: true })
            this.props.setRandomProductIsLoading(true)

            const a = getSelectedAltLevels()

            getRandomProduct(form, queries, templateId, preferredProductId, altTemplateId, a?.levels, a?.mode)
                .then((response: AxiosResponse<RandomProduct>) => {
                    const newRandomProduct: RandomProduct = {
                        ...response.data,
                        isLoading: false,
                        isLoaded: true,
                        isError: null,
                    }

                    if (!preferredProductId) {
                        this.props.change('templateForm', 'random_product_id', newRandomProduct.id)
                    }

                    if (newRandomProduct.palette) {
                        if (newRandomProduct.palette[1]) {
                            this.props.change('brushForm', 'color', newRandomProduct.palette[1])
                        } else if (newRandomProduct.palette[0]) {
                            this.props.change('brushForm', 'color', newRandomProduct.palette[0])
                        }
                    }

                    //apply effects now
                    //this should be set before background removed is applied
                    this.props.setRandomProduct(newRandomProduct)
                    this.setState({ isLoadingRandomProduct: false })

                    if (response.data.error) {
                        console.error(`error while reading random product  ${newRandomProduct.id} (${newRandomProduct.image_link}): ${newRandomProduct.error}`)
                    } else {
                        console.debug(`----------------------------------- product loaded ${newRandomProduct.id} ${response.data.width}x${response.data.height} ${response.data.error || ''}`)    //, response.data
                    }

                    if (newRandomProduct.error) {
                        this.createErrorToast(newRandomProduct.error)
                    }

                    if (this.shouldUpdateEffects) {
                        this.updateEffects(newRandomProduct.id, form.effects, form.is_autocrop, a?.levels, a?.mode, null, newRandomProduct)
                    }
                })
                .catch((e) => {
                    this.props.setRandomProduct({
                        ...this.props.randomProduct,
                        isLoaded: false,
                        isLoading: false,
                        isError: true,
                    })
                    console.error('get random product error', e)
                })
                .finally(() => {
                    this.props.setRandomProductIsLoading(false)
                    this.setState({ isLoadingRandomProduct: false })
                })
        } else {
            console.debug('cannot refresh product')
        }
    }


    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        const { confirmedNavigation, isAskBeforeLeave } = this.state
        const { blockNavigation, randomProduct, form } = this.props


        if (prevProps && Object.keys(prevProps).length > 0) {
            if (this.props.randomProduct && prevProps.randomProduct && this.props.randomProduct.id !== prevProps.randomProduct.id) {
                console.debug(`random product id changed, reset counter ${prevProps.randomProduct.id} --> ${this.props.randomProduct.id}`)

                this.publishCounter = 0
                this.updateEffectsCounter = 0
            }

            const prevForm = prevProps && typeof prevProps.isAlt !== 'undefined' ? prevProps?.form : null
            if (prevForm) {
                if (this.props.form.id !== prevForm.id) {
                    console.debug('!!!!!!!!!!! different form id, clear history')
                    //reset history
                    this.props.clearHistory(form)
                    this.props.setActiveShapeId(null)
                } else if (isAskBeforeLeave) {
                    const isSaved = isTemplateSaved()
                    //console.debug('DEBUG: CHECK', {isSaved, blockNavigation, confirmedNavigation})
                    if (!confirmedNavigation && isSaved === false && !blockNavigation) {
                        this.props.setBlockNavigation(true)
                    } else if (isSaved && this.props.blockNavigation) {
                        this.props.setBlockNavigation(false)
                    }
                }

                if (randomProduct && prevForm && typeof prevForm.type !== 'undefined' && (
                    (this.props.form.type !== prevForm.type) ||
                    (this.props.form.effect_sensitivity !== prevForm.effect_sensitivity) ||
                    (this.props.form.outpaint_over !== prevForm.outpaint_over) ||
                    (this.props.form.overscan !== prevProps.form.overscan) ||
                    (this.props.form.translate_x !== prevProps.form.translate_x) ||
                    (this.props.form.translate_y !== prevProps.form.translate_y) ||
                    (this.props.form.is_autocrop !== prevForm.is_autocrop) ||
                    (this.props.form.size?.width !== prevForm.size?.width) ||
                    (this.props.form.size?.height !== prevForm.size?.height) ||
                    (this.props.alternativeTemplatesLevels !== prevProps.alternativeTemplatesLevels)
                )) {
                    const a = getSelectedAltLevels()
                    this.shouldUpdateEffects = true
                    this.publishCounter = 0
                    this.updateEffectsCounter = 0

                    this.setState({
                        isProcessing: false,
                    })

                    const isOutpaintOver = canBeOutpaintedOver(form.outpaint_over, form.overscan, form.translate_x, form.translate_y)
                    if (this.props.form.type === RENDERED_TYPE_OUTPAINTING && isOutpaintOver) {
                        this.setState({ willUpdate: true })
                        clearTimeout(this.timer);
                        this.timer = setTimeout(() => {
                            this.setState({ willUpdate: false })    //wait until everything is set
                            console.debug('..................................................... timeout reached ............................................................')
                            this.updateEffectsDebounced(randomProduct.id, this.props.form.effects, this.props.form.is_autocrop, a?.levels, a?.mode)
                        }, 2000)
                    } else {
                        console.debug('..................................................... update now, no timeout ............................................................')
                        this.updateEffectsDebounced(randomProduct.id, this.props.form.effects, this.props.form.is_autocrop, a?.levels, a?.mode)
                    }
                }

                if (this.state.showAsModal === null && (    //show form again:
                    prevProps.activeView !== this.props.activeView ||
                    prevForm?.type !== this.props.form?.type ||
                    prevForm?.inpainting_group_id !== this.props.form?.inpainting_group_id
                )) {
                    this.setState({ showAsModal: false })
                }
            }
        }
    }

    handleBlockedNavigation = (nextLocation) => {
        const { confirmedNavigation, isAskBeforeLeave } = this.state

        if (isAskBeforeLeave && !confirmedNavigation && !isTemplateSaved()) {
            modal({
                overlayClassName: 'ask-before-leave-modal',
                title: <em>{trans('ask_save_before_leave_title')}</em>,
                message: (close) =>
                    <StyledConfirmDiv>
                        <div style={{ padding: '20px 0' }}>
                            {trans('ask_save_before_leave')}
                        </div>

                        <Grid cols="repeat(auto-fit, minmax(100px, 1fr))" gap={"5px"}>
                            <GridCell style={{ display: 'block' }}>
                                <Button
                                    icon={<Icon type={'check-slim'} text={trans("ask_save_before_leave_ok")} />}
                                    color='green'
                                    type='void'
                                    onClick={() => {
                                        this.setState({
                                            confirmedNavigation: true
                                        }, () => {
                                            this.props.router.navigate(nextLocation.pathname)
                                        })
                                        close()
                                    }} />
                            </GridCell>
                            <GridCell>
                                <Button
                                    icon={<Icon type={'close-light'} text={trans("ask_save_before_leave_nope")} />}
                                    color='red'
                                    type='void'
                                    onClick={() => {
                                        this.setState({ confirmedNavigation: false })
                                        close()
                                    }} />
                            </GridCell>
                        </Grid>
                    </StyledConfirmDiv>
            })

            return confirmedNavigation
        }

        return true
    }

    shouldShowModal = (): boolean => {
        const { watermarkGroups, form, isAlt } = this.props

        const selectedGroupId = form?.watermark_group_id || null

        const selectedGroup: WatermarkGroupType = watermarkGroups.isLoaded && selectedGroupId ? find(watermarkGroups.data, (watermarkGroup: WatermarkGroupType) => {
            return `${watermarkGroup.id}` === `${selectedGroupId}`
        }) : null

        const imagesWithMasksInSelectedGroup = selectedGroup && selectedGroup.images ? selectedGroup.images.filter(i => i.user_set_objects).length : 0
        const isDifferentPublishedHash = selectedGroup?.published_hash && selectedGroup?.group_hash !== selectedGroup?.published_hash

        return (
            window.location.pathname.endsWith('/templates/new') ||
            watermarkGroups.data.length === 0 ||
            isDifferentPublishedHash
        )
    }

    render(): JSX.Element {
        const { randomProduct, watermarkGroups, activeView, form, isAlt, templateId, altTemplateId, alternativeTemplatesLevels } = this.props
        const { mouseOverShape, isProcessing, isLoadingRandomProduct, isUpdatingEffects, willUpdate, processingProductId } = this.state

        const formName = getFormName(isAlt)

        const selectedGroupId = form?.watermark_group_id || null

        const selectedGroup: WatermarkGroupType = watermarkGroups.isLoaded && selectedGroupId ? find(watermarkGroups.data, (watermarkGroup: WatermarkGroupType) => {
            return `${watermarkGroup.id}` === `${selectedGroupId}`
        }) : null

        const isSaved = isTemplateSaved()
        const imagesWithMasksInSelectedGroup = selectedGroup && selectedGroup.images ? selectedGroup.images.filter(i => i.user_set_objects).length : 0
        const isDifferentPublishedHash = selectedGroup?.published_hash && selectedGroup?.group_hash !== selectedGroup?.published_hash

        const isEffectActiveAndReady = form?.watermark_group_id !== null && selectedGroup?.published_hash && !isDifferentPublishedHash && imagesWithMasksInSelectedGroup >= MIN_IMAGES_WITH_MASKS_TO_PUBLISH

        const showRemoveWatermarkForm = form.type === RENDERED_TYPE_AUTOWMREMOVE && watermarkGroups.isLoaded && (
            activeView === ACTIVE_VIEW_EDIT_EFFECTS || (activeView === ACTIVE_VIEW_EDIT_QUERIES && !isEffectActiveAndReady)
        )

        const showInpaintingForm = form.type === RENDERED_TYPE_INPAINTING && watermarkGroups.isLoaded && (this.state.showAsModal !== null) && (
            activeView === ACTIVE_VIEW_EDIT_EFFECTS || (activeView === ACTIVE_VIEW_EDIT_QUERIES && !isEffectActiveAndReady)
        )

        const isLoading = (isProcessing && (processingProductId && processingProductId === randomProduct.id)) || isLoadingRandomProduct || isUpdatingEffects || willUpdate

        const a = getSelectedAltLevels()

        return (
            <React.Fragment>
                {/*<Prompt
                    when={!isTemplateSaved}
                    message={this.handleBlockedNavigation}
                />*/}

                {/* {window.location.pathname.endsWith('/templates/new') &&
                    <NewTemplateModalOld key="modalbox" />
                } */}

                <StyledEditorGrid>
                    {showRemoveWatermarkForm &&
                        <WatermarksInEditor
                            updateWatermarkGroups={this.updateWatermarkGroups}
                            setSelectedGroupId={(watermarkGroupId: number) => this.props.change(formName, 'watermark_group_id', watermarkGroupId)}
                            selectedGroupId={form.watermark_group_id}
                            showAsModal={this.state.showAsModal}
                            setShowAsModal={this.setShowAsModal}
                        />
                    }

                    {showInpaintingForm &&
                        <InpaintingInEditor
                            updateInpaingGroups={this.updateInpaintingGroups}
                            setSelectedGroupId={(inpaintingGroupId: number) => this.props.change(formName, 'inpainting_group_id', inpaintingGroupId)}
                            selectedGroupId={form.inpainting_group_id}
                            showAsModal={this.state.showAsModal}
                            setShowAsModal={this.setShowAsModal}
                            templateId={templateId}
                            altTemplateId={altTemplateId}
                        />
                    }

                    {!showRemoveWatermarkForm && !showInpaintingForm &&
                        <ToolsPanel
                            handleImageRefresh={this.handleImageRefresh}
                            sameImageInPreview={this.state.sameImageInPreview}
                            toggleSameImageInPreview={this.toggleSameImageInPreview}
                            isSaved={isSaved}
                            updateZoom={this.updateZoom}
                            updateTranslate={this.updateTranslate}
                            canvasZoom={this.state.canvasZoom}
                            canvasTranslate={this.state.canvasTranslate}
                            isLoading={isLoading}
                            templateId={templateId}
                            altTemplateId={altTemplateId}
                            levels={a?.levels}
                            levelsMode={a?.mode}
                        />
                    }

                    {form?.shapes ?
                        <React.Fragment>
                            {!showRemoveWatermarkForm && !showInpaintingForm &&
                                <ImagePreview
                                    levels={a?.levels}
                                    levelsMode={a?.mode}
                                    sameImageInPreview={this.state.sameImageInPreview}
                                    toggleSameImageInPreview={this.toggleSameImageInPreview}
                                    updateZoom={this.updateZoom}
                                    updateTranslate={this.updateTranslate}
                                    canvasZoom={this.state.canvasZoom}
                                    canvasTranslate={this.state.canvasTranslate}
                                    mouseOverShape={mouseOverShape}
                                    setMouseOverShape={this.setMouseOverShape}
                                    showOverlap={!this.props.projectSettings?.disable_show_overlap}
                                    setShowOverlap={this.setShowOverlap}
                                    isLoading={isLoading}
                                />
                            }

                            <RightPanel
                                mouseOverShape={mouseOverShape}
                                setMouseOverShape={this.setMouseOverShape}
                                updateEffects={this.updateEffects}
                                showOverlap={!this.props.projectSettings?.disable_show_overlap}
                                setShowOverlap={this.setShowOverlap}
                                handleImageRefresh={this.handleImageRefresh}
                                setShowAsModal={this.setShowAsModal}
                                showAsModal={this.state.showAsModal}
                            />
                        </React.Fragment> :
                        <div title={'loading template form shapes'} style={{ textAlign: 'center' }}>
                            <Icon type={'spinner'} text={'no layers'} />
                        </div>
                    }
                </StyledEditorGrid>

                <Helper />
            </React.Fragment>
        )
    }
}

const StyledEditorGrid = css(Grid)({
    //gridTemplateColumns: 'auto minmax(67%, 1fr) 42px minmax(440px, 32%)',
    gridTemplateColumns: 'auto 1fr 42px minmax(440px, 32%)',
    width: '100%',
    ".muk-button:active, .muk-button:focus": {
        boxShadow: "none !important",
    },
    ' .preview-canvas': {
        zIndex: 10,
        overflow: 'hidden',
        webkitBackgroundSize: '4px 4px',
        mozBackgroundSize: '4px 4px',
        backgroundSize: '4px 4px',
        margin: '0 10px',
        textAlign: 'center',
        maxHeight: "calc(100vh - 110px)",
        '@media screen and (max-width: 1024px)': {
            maxHeight: "calc(100vh - 100px)",
        },
        ' svg#image': {
            width: 'auto',
            height: 'auto',
            overflow: 'hidden',
        },
    },
    '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: '40px  calc(100vw - 90px) 42px minmax(100vw, max-content)',
    },
    '@media screen and (max-width: 800px)': {
        paddingBottom: '100px', //bottom padding for mobile
    },
    ' .padding-right': {
        paddingRight: '10px',
        overflowY: 'auto',
    },
})

const StyledConfirmDiv = css("div")({
    ' .m-button-void': {
        padding: '2px 15px',
    },
    ' h1': {
        fontSize: '22px',
    },
})

function mapStateToProps(state) {
    return {
        project: state.project.data,
        blockNavigation: state.blockNavigation,
        isAlt: state.isAlt,
        queries: selectFormValue(state, 'templateForm', 'queries'),
        form: selectFormValues(state, getFormName(state.isAlt)),
        projectSettings: selectFormValues(state, 'settingsForm'),
        brushForm: selectFormValues(state, 'brushForm'),
        alternativeTemplatesLevels: state.alternativeTemplatesLevels,
        randomProduct: state.randomProduct,
        sourceImage: state.sourceImage,
        undoRedoHistory: state.undoRedoHistory,
        watermarkGroups: state.watermarkGroups,
        activeView: state.activeView,
        lockedLayers: state.lockedLayers,
    }
}

export default connect(mapStateToProps, {
    setRandomProduct,
    setRandomProductIsLoading,
    setActiveShapeId,
    setActiveGroupId,
    setActiveView,
    setBlockNavigation,
    selectLayers,
    undoHistory,
    redoHistory,
    clearHistory,
    initForm,
    setWatermarkGroupsToStore,
    setInpaintingGroupsToStore,
    setFontsInProjectToStore,
    change,
})(withRouter(Editor))